import { FiberManualRecord } from '@mui/icons-material';
import { Box, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Images from '../../../utils/Images';
import { useNavigate } from 'react-router-dom';

const SubscriptionSuccess = () => {
  const [sub, setSub] = useState(null);
  const navigate = useNavigate();
  const taxPercent = parseFloat(sub?.taxPercent || '0');
  const price = parseFloat(sub?.price || '0');
  const taxAmount = (price * taxPercent) / 100;
  const totalPayable = price + taxAmount;
  const durationDays = parseInt(sub?.duration || "0", 10);
  const startDateObj = new Date();
  const endDateObj = new Date();
  endDateObj.setDate(startDateObj.getDate() + durationDays);
  const dateFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
  const startDate = startDateObj.toLocaleDateString('en-GB', dateFormatOptions);
  const endDate = endDateObj.toLocaleDateString('en-GB', dateFormatOptions);

  useEffect(() => {
    const raw = localStorage.getItem('subscriptionPurchaseData');
    if (raw) {
      setSub(JSON.parse(raw));
      localStorage.removeItem('subscriptionPurchaseData');
    }
  }, []);

  if (!sub) {
    // Optionally show loader or fallback message
    return <div>Loading subscription details...</div>;
  }

  return (
    <Box className="subscriptionPurchase">
      <Box padding={2}>
        <img style={{ width: '100%' }} src={sub.banner_imageUrl} />
      </Box>
      <img style={{ width: '100%' }} src={Images.subDetailBanner} />

      <Box padding={2}>
        <Typography className='title'>{sub?.title}</Typography>
        <Typography className='description' >{sub?.description}</Typography>

        {sub?.subscriptionWorking?.length > 0 && (
          <>
            <Typography className='workTitle'>How does it work?</Typography>
            <Typography className='workPoints'>After you purchase this subscription</Typography>
          </>
        )}
        <List dense>
          {sub?.subscriptionWorking?.map((item, index) => (
            <ListItem key={index} sx={{ alignItems: 'center', py: 0.5 }}>
              <ListItemIcon
                sx={{
                  minWidth: '24px',
                  display: 'flex',
                  alignItems: 'center', // vertical center
                  justifyContent: 'center', // horizontal center if needed
                  mt: -1, // ensure no vertical offset
                }}
              >
                <FiberManualRecord sx={{ fontSize: 8, color: '#858585' }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { fontSize: 14 } }}
                className="workPoints"
                primary={item}
              />
            </ListItem>
          ))}
        </List>
        {sub?.termsConditions?.length > 0 && (
          <Typography className='workTitle'>Terms & Conditions</Typography>
        )}
        <List dense>
          {sub?.termsConditions?.map((item, index) => (
            <ListItem key={index} sx={{ alignItems: 'center', py: 0.5, m: 0 }}>
              <ListItemIcon
                sx={{
                  minWidth: '24px',
                  display: 'flex',
                  alignItems: 'center', // vertical center
                  justifyContent: 'center', // horizontal center if needed
                  mt: -1, // ensure no vertical offset
                }}
              >
                <FiberManualRecord sx={{ fontSize: 8, color: '#858585' }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { fontSize: 14, m: 0, p: 0 } }}
                className="workPoints"
                primary={item}
              />
            </ListItem>
          ))}
        </List>

        <Box sx={{ borderTop: '1px solid #0E4961', borderBottom: '1px solid #0E4961' }}>
          <Typography color={'#0E4961'} variant='body2'>Plan Start Date: <b>{startDate}</b></Typography>
          <Typography color={'#0E4961'} variant='body2' sx={{ pb: 1 }}>Plan End Date: <b>{endDate}</b></Typography>
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          Order Summary
        </Typography>
        <Stack spacing={1}>
          <Grid container justifyContent="space-between">
            <Typography>Item</Typography>
            <Typography>01</Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography>Order Total</Typography>
            <Typography>₹{sub?.price}</Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography>Taxes ({taxPercent}%)</Typography>
            <Typography>₹{taxAmount?.toFixed(2)}</Typography>
          </Grid>
          <Divider sx={{ my: 1 }} />
          <Grid container justifyContent="space-between">
            <Typography fontWeight={600}>Total Payable</Typography>
            <Typography fontWeight={600}>₹{totalPayable?.toFixed(2)}</Typography>
          </Grid>
        </Stack>

        <Box onClick={() => navigate('/subscriptions')} sx={{ borderRadius: 0, bgcolor: '#00AB55', px: 5, py: 1, borderRadius: '40px', textTransform: 'none', color: '#fff', textAlign: 'center' }}>
          Go back to menu
        </Box>
      </Box>
    </Box>
  )
}

export default SubscriptionSuccess;
